export class FinalUsersList {
    Id?: number;
    Name = '';
    CategoryId?: number;
    CreatedAt?: Date;
    UpdatedAt?: Date;
}
